import { SWRConfiguration } from 'swr';
import { SWRInfiniteConfiguration } from 'swr/infinite';

export const DEFAULT_OPTIONS: SWRConfiguration = {
  revalidateOnFocus: true,
  revalidateIfStale: true,
  revalidateOnMount: true,
  revalidateOnReconnect: true,
  refreshWhenHidden: false,
  refreshWhenOffline: false,
  keepPreviousData: true,
};

export const DEFAULT_INFINITE_OPTIONS: SWRInfiniteConfiguration = {
  revalidateAll: false,
};

// HTTP status codes we should not retry requests on. Consumers can use this list
// to implement custom retry logic with SWR without altering the global defaults.
export const NON_RETRIABLE_STATUS_CODES: readonly number[] = [
  // Client errors that require changing the request
  400, // Bad Request
  // 401 handled conditionally by callers (after refresh); keep listed to discourage blind retries
  403, // Forbidden
  404, // Not Found
  405, // Method Not Allowed
  406, // Not Acceptable
  409, // Conflict (handle explicitly)
  410, // Gone
  411, // Length Required
  412, // Precondition Failed
  413, // Payload Too Large
  414, // URI Too Long
  415, // Unsupported Media Type
  416, // Range Not Satisfiable
  417, // Expectation Failed
  422, // Unprocessable Entity
  423, // Locked
  424, // Failed Dependency
  426, // Upgrade Required
  428, // Precondition Required
  431, // Request Header Fields Too Large
  451, // Unavailable For Legal Reasons
  // Server responses that should not be retried blindly
  501, // Not Implemented
  505, // HTTP Version Not Supported
] as const;
